<div class="box-plugin box-single" *ngIf="!errorCompare">
    <!-- /////////////// Comparison Report ///////////// -->
    <core-helpers-box-loading *ngIf="loading"></core-helpers-box-loading>
    <plugin-apollo-helpers-modal-content *ngIf="!loading && showModal" (action)="actionModal($event, true)"></plugin-apollo-helpers-modal-content>

    <div *ngIf="!loading && !showModal">
        <div class="comparison-report">
            <!-- /////////////// TOOLS BAR ///////////// -->
            <div class="tools" >
                <!-- <core-helpers-forms-select [disabled]="disabledSelect" [optionSelected]="optionSelected" [label]="'Method'" [options]="optionsCompare" (select)="newCompare($event)"></core-helpers-forms-select> -->
                <plugin-apollo-helpers-tools-bar [values]="options" [optionSelected]="optionSelected" [disabled]="!imgLoaded" (onChange)="newCompare($event)"></plugin-apollo-helpers-tools-bar>
                <div class="links">
                    <ul>
                        <li> <button (click)="showInspector = !showInspector"  [ngClass]="{'disabled-link' : preview == null, 'active-button': showInspector}">Inspector</button></li>
                        <li><a href="{{reportUrl}}" [ngClass]="{'disabled-link' : preview == null || reportUrl == null}" class="download-report" ><em>Report</em></a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="compared-target" *ngIf="apolloContent.images.status_code == 2">
            <div *ngIf="preview != null">
                <core-helpers-box-loading *ngIf="preview.status_code == 0"></core-helpers-box-loading>
                <core-previews-carousel [hidden]="preview.total_pages == 1 || (preview.total_pages - ignorePages().length)<2" *ngIf="preview.status_code==1" [selectedPage]="page" [hiddenPages]="ignorePages()" [preview]="preview" (onClickPage)="setPage($event)" [rotateAction]="false"></core-previews-carousel>
                <div class="list-changes">
                    <fieldset class="change-tool">
                        <h3>Total matches: <em>{{totalMatches()}}</em></h3>
                        <!-- <h3>Total changes: <em>{{inspectorCtrl.changeList.length + inspectorCtrl.orphanRefList.length}}</em></h3> -->
                        <div class="buttons">
                            <button (click)="showChanges = !showChanges" [ngClass]="{'active-button': showChanges}">List changes</button>
                            <button class="filter-button" [ngClass]="{'active-button': showFilterList}" (click)="showFilterList = !showFilterList">Filter</button>
                        </div>
                    </fieldset>
                    <div class="filter-list" [hidden]="!showFilterList">
                        <form>
                            <ul class="filter-checklist first-list">
                                <li class="del-match">
                                    <label for="del" class="checklabel"><em><strong></strong>Deleted text</em>
                                        <input type="checkbox" id="del" (change)="selectFilter($event)" checked/><span class="checkmark"></span>
                                    </label>
                                </li>
                                <li class="ins-match">
                                    <label for="ins" class="checklabel"><em><strong></strong>Inserted text</em>
                                        <input type="checkbox" id="ins" (change)="selectFilter($event)" checked /><span class="checkmark"></span>
                                    </label>
                                </li>
                                <li class="subst-match">
                                    <label for="subst" class="checklabel"><em><strong></strong>Changed text</em>
                                        <input type="checkbox" id="subst" (change)="selectFilter($event)" checked/><span class="checkmark"></span>
                                    </label>
                                </li>
                                <li class="onlystyle-match">
                                    <label for="onlystyle" class="checklabel"><em><strong></strong>Style change</em>
                                        <input type="checkbox" id="onlystyle" (change)="selectFilter($event)" checked/><span class="checkmark"></span>
                                    </label>
                                </li>
                                <li class="correct-match">
                                    <label for="none" class="checklabel"><em><strong></strong>Correct match</em>
                                        <input type="checkbox" id="none" (change)="selectFilter($event)"/><span class="checkmark"></span>
                                    </label>
                                </li>
                            </ul>
                            <ul class="filter-checklist second-list">
                                <li class="accepted-match">
                                    <label for="accepted" class="checklabel"><em><strong>Accepted</strong> changes</em>
                                        <input type="checkbox" id="accepted" (change)="selectApprovalFilter($event)"/><span class="checkmark"></span>
                                    </label>
                                </li>
                                <li class="rejected-match">
                                    <label for="rejected" class="checklabel"><em><strong>Rejected</strong> changes</em>
                                        <input type="checkbox" id="rejected" (change)="selectApprovalFilter($event)"/><span class="checkmark"></span>
                                    </label>
                                </li>
                            </ul>
                        </form>
                    </div>
                    <div class="changes-list" *ngIf="showChanges">
                        <ol>
                            <li *ngFor="let change of inspectorCtrl.changeList" class="{{change.change}}" [ngClass]="{'selected': inspectorCtrl.isSelectedWord(change)}" [hidden]="!isFilterActive(change)">
                              <div class="content-li">
                                <div class="results-li">
                                  <span (click)="selectWord(change)"><em><strong>{{change.text}}</strong></em></span>
                                  <span *ngIf="isApprovedStatus(1, change)" class="accepted-tag">Accepted</span>
                                  <span *ngIf="isApprovedStatus(2, change)" class="rejected-tag">Rejected</span>
                                </div>
                                <!-- BUTTONS ACCEPT REJECT RESET -->
                                <div class="buttons-li">
                                    <button *ngIf="!isApprovedStatus(0, change)" title="Reset Changes" (click)="approvalMatchButtons(0, change)" class="li-reset">Reset</button>
                                    <button *ngIf="isApprovedStatus(0, change)" title="Accept Match" (click)="approvalMatchButtons(1, change)" class="li-accept"><em>Accept</em></button>
                                    <button *ngIf="isApprovedStatus(0, change)" title="Reject Match" (click)="approvalMatchButtons(2, change)" class="li-reject"><em>Reject</em></button>
                                </div>
                              </div>
                            </li>
                        </ol>

                        <div class="changes-list-additional" [hidden]="getChangesOrphanRefFilters() == 0">
                            <h3>Additional Changes in Reference</h3>
                            <ol>
                                <li *ngFor="let change of inspectorCtrl.orphanRefList" class="{{change.change}}" [ngClass]="{'selected': inspectorCtrl.isSelectedWord(change)}" [hidden]="!inspectorCtrl.isFilterActive(change)">
                                    <span (click)="selectWord(change)"><em><strong>{{change.text}}</strong></em></span>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <!-- /////////////// INSPECTOR ///////////// -->
                    <div #inspector>
                        <plugin-apollo-helpers-content-inspector
                        *ngIf="showInspector"
                        [inspectorCtrl]="inspectorCtrl"
                        [approvalsCtrl]="approvalsCtrl"
                        (eventApprovalMatch)="approvalMatch($event, 'inspector')"
                        >
                        </plugin-apollo-helpers-content-inspector>
                    </div>

                    <core-helpers-box-loading *ngIf="!imgLoaded"></core-helpers-box-loading>
                    <figure [hidden]="!imgLoaded">
                        <div [hidden]="!imgLoaded" class="marker-main" 
                            coreSizeMe
                            [monitorHeight]="true"
                            [state]="size"
                            (resize)="viewerResize($event)">
                            <!-- image -->
                            <!-- (NOTE: moved directive coreSizeMe (old sizeMe) to <img> parent due to solve inspector marks positioning )-->
                            <img
                            [src]="inspectorCtrl.tarImageSrc"
                            (load)="imageLoad($event)"
                            alt="page {{inspectorCtrl.tarPage}}"
                            />

                            <!-- lupa -->
                            <div *ngIf="imgLoaded"
                            [hidden]="!markHover"
                            class="mark-zoom"
                            [ngStyle]="lupa.style"
                            [ngClass]="lupa.class"
                            (mouseleave)="lupaOut()"
                            (click)="selectMark(lupa.mark)"
                            ><div class="mask"></div></div>

                            <!-- marks -->
                            <plugin-apollo-helpers-content-result-mark
                            *ngFor="let mark of inspectorCtrl.viewerMarks"
                            (mouseenter)="lupaIn(mark)"
                            (mouseover)="lupa.setMark($event, mark)"
                            (click)="selectMark(mark)"
                            [mark]="mark"
                            [ngStyle]="{'lupa': isLupaMark(mark)}"
                            [selected]="inspectorCtrl.isSelectedMark(mark)"
                            [hidden]="!isFilterActive(mark)">
                            </plugin-apollo-helpers-content-result-mark>
                        </div>


                    </figure>
                </div>
            </div>
            <core-helpers-box-loading *ngIf="preview == null"></core-helpers-box-loading>
        </div>

    </div>
</div>

<!-- ERRORS messages -->
<div class="alert-try-again" *ngIf="error.code==1 && errorCompare">
    <div class="first-message">{{error.message}}</div>
    <div class="error-content">
      <div class="left-content">
        <span>Try again with other files.</span>
        <div class="fieldset">
          <core-helpers-forms-button [text]="'Return to upload'" (submit)="goToUpload()"></core-helpers-forms-button>
        </div>
      </div>
      <div class="right-content">
        <span>You can also try the ORDERED text method.</span>
        <div class="fieldset">
          <core-helpers-forms-button [text]="'Ordered'" (submit)="tryOrdered('comparison')"></core-helpers-forms-button>
        </div>
      </div>
  </div>
</div>

<core-helpers-box-alert-try-again *ngIf="error.code==0 && errorCompare" [text]="'It looks like something went wrong and we could not compare the contents of the files. Please try again.'" (tryAgain)="tryAgain()" [textButton]="'Try Again'">
</core-helpers-box-alert-try-again>
